import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { isClientTaxExempt } from '~/models/ClientModel';
export const savedAgreementTax = (tax)=>tax == null || tax.type === 'none' ? null : tax;
export const taxPresetFromRateDTO = (rate)=>_object_spread({
        id: rate.id,
        name: rate.name,
        status: 'active',
        combinedRate: rate.combinedRate,
        components: rate.components.map((component)=>({
                id: component.id,
                name: component.name,
                rate: component.rate
            }))
    }, rate.mappingStatus != null ? {
        mappingStatus: rate.mappingStatus
    } : {});
export const salesTaxConfigFromDTO = (dto)=>({
        enabled: dto.enabled,
        displayMode: dto.displayMode,
        label: dto.label,
        presets: dto.rates.map(taxPresetFromRateDTO)
    });
export const rateWriteBody = (preset, components)=>({
        name: preset.name,
        components
    });
const normalizedName = (name)=>name.trim().toLowerCase();
const planComponentEntry = (component, pool)=>{
    const pooled = pool.find((candidate)=>normalizedName(candidate.name) === normalizedName(component.name));
    if (pooled == null) {
        return {
            type: 'create',
            create: {
                name: component.name,
                rate: component.rate
            }
        };
    }
    return pooled.rate === component.rate ? {
        type: 'reference',
        reference: {
            id: pooled.id
        }
    } : {
        type: 'update',
        update: {
            id: pooled.id,
            name: pooled.name,
            rate: component.rate
        }
    };
};
export const planComponentEntries = (param)=>{
    let { components, pool } = param;
    return components.map((component)=>planComponentEntry(component, pool));
};
export const hasPoolWrite = (entries)=>entries.some((entry)=>entry.type !== 'reference');
export const componentSuggestionsFromPool = (pool)=>pool.map((component)=>({
            name: component.name,
            rate: component.rate,
            subLabel: formatPercent(component.rate)
        }));
export const formatPercent = (rate)=>{
    const n = typeof rate === 'string' ? parseFloat(rate) : rate;
    if (Number.isNaN(n)) return '0.00%';
    return "".concat(n.toFixed(2), "%");
};
export const addPreset = (config, next)=>_object_spread_props(_object_spread({}, config), {
        presets: [
            ...config.presets,
            next
        ]
    });
export const isDuplicateName = (presets, name, excludingId)=>presets.some((p)=>p.id !== excludingId && p.name.trim().toLowerCase() === name.trim().toLowerCase());
export const isPresetMapped = (preset)=>{
    var _ref;
    var _preset_mappingStatus;
    return (_ref = preset === null || preset === void 0 ? void 0 : (_preset_mappingStatus = preset.mappingStatus) === null || _preset_mappingStatus === void 0 ? void 0 : _preset_mappingStatus.some((m)=>m.status !== 'unmapped')) !== null && _ref !== void 0 ? _ref : false;
};
export const presetMappingStatusFor = (preset, integrationName)=>{
    var _ref;
    var _preset_mappingStatus_find, _preset_mappingStatus;
    return (_ref = (_preset_mappingStatus = preset.mappingStatus) === null || _preset_mappingStatus === void 0 ? void 0 : (_preset_mappingStatus_find = _preset_mappingStatus.find((m)=>m.integrationName === integrationName)) === null || _preset_mappingStatus_find === void 0 ? void 0 : _preset_mappingStatus_find.status) !== null && _ref !== void 0 ? _ref : 'unmapped';
};
export const needsTaxRate = (param)=>{
    let { presetId, lines, clientTaxSettings, config } = param;
    if ((config === null || config === void 0 ? void 0 : config.enabled) !== true) return false;
    if (clientTaxSettings != null && isClientTaxExempt(clientTaxSettings)) return false;
    if (!lines.some((line)=>line.taxable)) return false;
    return presetId == null;
};
export function isServiceTaxable(service) {
    var _service_taxable;
    return (_service_taxable = service.taxable) !== null && _service_taxable !== void 0 ? _service_taxable : false;
}
